import { AxiosError } from 'axios';
import { useState } from 'react';

import { ErrorHttpResponse, HttpConfig, SuccessHttpResponse } from '../../../models/https';
import useHttps from '../../useHttps';

const useDriverInfoStats = () => {
    const request = useHttps();
    const [loading, setLoading] = useState(false);


    const onDriverInfoStatsError = (err: AxiosError<ErrorHttpResponse>) => {
        console.error(
            err?.response?.data?.message ?? 'Something went wrong while accepting kyc.',
        );
    };

    const onDriverInfoStatsSuccess = ({
        data,
        message,
    }: SuccessHttpResponse<any>) => {
        //
    };

    const driverInfoStats = async (companyId: any) => {
        const url: HttpConfig = {
            url: `ba/v1/company/${companyId}/driver-info/stats`,
            method: 'get',
        };

        await request(url, onDriverInfoStatsSuccess, setLoading, onDriverInfoStatsError);
    };

    return { driverInfoStats, loading };
};

export default useDriverInfoStats;
